module.exports = __webpack_public_path__ + "static/media/206-gallery09.5b32ec35.jpg";